import React, { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import { Typography, TextField, Grid } from "@mui/material";
import ToggleButton from "../../ToggleButton";
import SearchBar from "../searchBar";
import Button from "../Button";
import CsvDownloader from "react-csv-downloader";
import { useNavigate } from "react-router-dom";
import { FOMRS } from "../../../globals/constants";
import Cookies from "universal-cookie";

const SubHeading = (props) => {
  const navigate = useNavigate();
  console.log("props", props);
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;

  const [flag, setFlag] = useState(false);
  const {
    switchHandler,
    searchChange,
    columns,
    datas,
    setShowModal,
    exportFile,
    redirect,
    title,
    checked,
    showFilter,
    setShowFilter,
    exportfileTitle,
    addText,
    multipleDeleteList,
  } = props;

  // useEffect(() => {
  // 	console.log('props', props);
  // }, []);

  return (
    <Grid container>
      <Grid item xs={12} sm={5} md={4} lg={4}>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="fl"
          marginLeft="5%"
          marginBottom={{ xs: "3%", md: "1%" }}
          marginTop="1%"
        >
          <Stack>
            <span className="larger_f_bold">{title}</span>
          </Stack>
          <Stack
            direction="row"
            display={{ xs: "none", sm: "none", md: "block" }}
          >
            <ToggleButton
              checked={checked}
              onClick={switchHandler}
              gridview={switchHandler}
            />
          </Stack>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={7} md={8} lg={8}>
        <Stack
          direction="row"
          spacing={{ xs: "-8px", sm: "1%" }}
          justifyContent={{ xs: "center", sm: "center", md: "flex-end" }}
          flexWrap="wrap"
          marginRight={"10%"}
          marginTop="1%"
        >
          <Stack
            direction="row"
            flexWrap="wrap"
            marginBottom={{ xs: "3%", md: "1%" }}
          >
            <SearchBar searchChange={searchChange} />
          </Stack>
          <Stack direction={"row"} spacing={{ xs: "2%", sm: "5%" }}>
            <Button
              value="Filter"
              role="filter"
              onClick={() => {
                setShowFilter(!showFilter);
              }}
            />
            {title === "Student" && userRole !== "STUDIO_ADMIN" ? (
              ""
            ) : checked === true ? (
              ""
            ) : (
              <Button
                value="Delete"
                role="delete"
                onClick={() => {
                  multipleDeleteList();
                }}
              />
            )}
            <CsvDownloader
              filename={exportfileTitle}
              extension=".csv"
              enclosingCharacter={``}
              separator=","
              columns={columns}
              datas={datas}
            >
              <Button
                value="Export"
                role="export"
                onClick={() => {
                  exportFile();
                }}
              />
            </CsvDownloader>
            {/* {userRole === "STUDIO_ADMIN" && title === "Student" ? (
              <Button
                style={{ display: showFilter ? "none" : "contents" }}
                value={addText}
                role="add"
                onClick={() => {
                  navigate(redirect, {
                    state: {
                      type: FOMRS.ADD,
                    },
                  });
                }}
              />
            ) : (
              ""
            )} */}
            {title === "Student" ? (
              ""
            ) : (
              <Button
                style={{ display: showFilter ? "none" : "contents" }}
                value={addText}
                role="add"
                onClick={() => {
                  navigate(redirect, {
                    state: {
                      type: FOMRS.ADD,
                    },
                  });
                }}
              />
            )}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SubHeading;
